import {AdvertisingPlatformCodeEnum} from '../sharedTypes';

export type PlatformCode = AdvertisingPlatformCodeEnum;
